const Attachment = (props) => (
	<svg
		viewBox="0 0 14 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M12 5.34766V17.3477C12 20.1047 9.757 22.3477 7 22.3477C4.243 22.3477 2 20.1047 2 17.3477V5.34766C2 3.69366 3.346 2.34766 5 2.34766C6.654 2.34766 8 3.69366 8 5.34766V14.3477C8 14.8987 7.551 15.3477 7 15.3477C6.449 15.3477 6 14.8987 6 14.3477V6.34766H4V14.3477C4 16.0047 5.343 17.3477 7 17.3477C8.657 17.3477 10 16.0047 10 14.3477V5.34766C10 2.58666 7.761 0.347656 5 0.347656C2.239 0.347656 0 2.58666 0 5.34766V17.3477C0 21.2137 3.134 24.3477 7 24.3477C10.866 24.3477 14 21.2137 14 17.3477V5.34766H12Z"
			fill="black"
		/>
	</svg>
);
export default Attachment;
